(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on mobile devices
    if (window.innerWidth <= 768) {
      let refreshing = false;
      let startY = 0;
      let pullDistance = 0;
      const threshold = 150; // How far user needs to pull
      
      // Create the refresh container
      const refreshContainer = document.createElement('div');
      refreshContainer.className = 'refresh-container';
      
      // Get the asset URL from the data attribute
      const assetUrl = document.getElementById('pull-to-refresh-script').getAttribute('data-character-asset');
      
      // Create just the character element
      refreshContainer.innerHTML = `
        <div class="refresh-character">
          <img src="${assetUrl}" alt="Pull to refresh">
        </div>
      `;
      
      document.body.appendChild(refreshContainer);
      
      // Get reference to character
      const character = refreshContainer.querySelector('.refresh-character');
      
      // Handle touch start
      document.addEventListener('touchstart', function(e) {
        if (window.scrollY === 0 && !refreshing) {
          startY = e.touches[0].clientY;
        }
      });
      
      // Handle touch move
      document.addEventListener('touchmove', function(e) {
        if (startY > 0 && window.scrollY === 0 && !refreshing) {
          pullDistance = e.touches[0].clientY - startY;
          
          if (pullDistance > 0) {
            // Prevent default scrolling behavior
            e.preventDefault();
            
            // Calculate progress percentage
            const progress = Math.min(pullDistance / threshold, 1);
            
            // Show the container
            refreshContainer.style.opacity = Math.min(progress * 1.5, 1);
            refreshContainer.style.visibility = 'visible';
            
            // Animate character
            character.style.transform = `translateY(${pullDistance / 3}px)`;
          }
        }
      }, { passive: false });
      
      // Handle touch end
      document.addEventListener('touchend', function() {
        if (pullDistance > threshold && !refreshing) {
          refreshing = true;
          
          // Update UI for loading state
          character.classList.add('refreshing');
          
          // Reload the page after animation
          setTimeout(function() {
            window.location.reload();
          }, 1500);
        } else {
          // Hide everything
          refreshContainer.style.opacity = '0';
          setTimeout(() => {
            refreshContainer.style.visibility = 'hidden';
            character.style.transform = 'translateY(0)';
          }, 300);
        }
        
        startY = 0;
        pullDistance = 0;
      });
    }
  });
})();